/* eslint-disable no-underscore-dangle */
import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import NPS from './NPS';
import StarRating from './StarRating';
import Sentiment from './Sentiment';

const Feedback = ({ experienceGetData, openHandler }) => (
  <div>
    <div className="qs-fade-in space-y-3">
      <div className="qs-title flex justify-center">
        <span>{experienceGetData?.experience_heading}</span>
      </div>
      <div className="qs-subtitle flex justify-center">
        {experienceGetData?.experience_body}
      </div>
    </div>

    <div className="mt-8">
      {experienceGetData?.template?.experience_type_ === '_nps' && (
      <div>
        <NPS 
          openHandler={openHandler}
          experienceGetData={experienceGetData}
        />
      </div>
      )}

      {experienceGetData?.template?.experience_type_ === '5_star_rating' && (
      <div>
        <StarRating
          openHandler={openHandler}
          experienceGetData={experienceGetData}
        />
      </div>
      )}

      {experienceGetData?.template?.experience_type_ === 'sentiment' && (
      <div>
        <Sentiment
          openHandler={openHandler}
          experienceGetData={experienceGetData}
        />
      </div>
      )}
    </div>
  </div>
);

export default Feedback;
